import {
  getProductData,
  getSourceData
} from '@/axios/api/topManagement'
import { Message } from 'element-ui'

const UPDATE_PRODUCT_LIST = 'UPDATE_PRODUCT_LIST'
const UPDATE_SOURCE_LIST = 'UPDATE_SOURCE_LIST'
const UPDATE_DETAIL_LOADING = 'UPDATE_DETAIL_LOADING'

const state = {
  productList: [],
  sourceList: [],
  detailLoading: false
}

const getters = {
  productList: state => state.productList,
  sourceList: state => state.sourceList,
  detailLoading: state => state.detailLoading
}

const mutations = {
  [UPDATE_PRODUCT_LIST] (state, productList) {
    state.productList = productList
  },
  [UPDATE_SOURCE_LIST] (state, sourceList) {
    state.sourceList = sourceList
  },
  [UPDATE_DETAIL_LOADING] (state, detailLoading) {
    state.detailLoading = detailLoading
  }
}

const actions = {
  async getProductDataApi ({ commit }, params) {
    try {
      const res = await getProductData(params)
      commit(UPDATE_PRODUCT_LIST, res)
    } catch (e) {

    }
  },
  async getSourceDataApi ({ commit }, params) {
    commit(UPDATE_DETAIL_LOADING, true)
    try {
      const res = await getSourceData(params)
      commit(UPDATE_SOURCE_LIST, res)
    } catch (e) {

    }
    commit(UPDATE_DETAIL_LOADING, false)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/topManagement.js